import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DIALOG_TYPES,
  Spinner,
  Typography,
} from 'components/alf-design';
import { reinstatementSuccess, reinstatementTime } from 'assets/icon';

const reinstatmentModalStyle = {
  loading: {
    icon: 'loading',
    title: 'Hang in there!',
    subtitle: 'Your policy is being reinstated.',
  },
  success: {
    icon: reinstatementSuccess,
    title: 'Success!',
    subtitle: 'Your policy has been reinstated.',
    button: true,
  },
  waiting: {
    icon: reinstatementTime,
    title: "It's taking a little longer than expected!",
    subtitle:
      'Please allow up to 2 business days for the reinstatement to reflect on your policy.',
    button: true,
  },
};

const ReinstatementModal = ({ show, onClose, type = 'loading' }) => {
  const modalStyle =
    reinstatmentModalStyle[type] || reinstatmentModalStyle.loading;

  return (
    <>
      <Dialog
        id="reinstatement-modal"
        type={DIALOG_TYPES.SIMPLE}
        show={show}
        onClose={onClose}
        primaryButtonText={modalStyle.button ? 'Close' : null}
        onPrimaryClick={onClose}
        ariaLabel="Reinstatement Modal"
        wrapperStyle={{ width: 420, padding: 48 }}
        reinstatementModalContent={
          <div className="text-center">
            {modalStyle.icon === 'loading' ? (
              <Spinner size={48} />
            ) : (
              <img
                alt="reinstatement-icon"
                src={modalStyle.icon}
                className="w-[48px] h-[48px] justify-self-center"
              />
            )}

            <Typography
              type="h2-claim"
              component="h1"
              className="w-full mt-[20px] mb-[10px]"
            >
              {modalStyle.title}
            </Typography>
            <Typography
              component="h2"
              className="w-full  !text-legacy-reinstatementSubtitle"
            >
              {modalStyle.subtitle}
            </Typography>
          </div>
        }
      ></Dialog>
    </>
  );
};

ReinstatementModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.string,
};

export default ReinstatementModal;
